import { useMemo } from 'react'
import useQuestionFilters from './useQuestionFilters'
import useVariableFilters from './useVariableFilters'
import useFilterValidation from './useFilterValidation'
import useFilterVariableValues from './useFilterVariableValues'

const useFilters = (collect, initialFilters) => {
  const { variableValues, loadVariableValues } = useFilterVariableValues(collect?.id)

  const {
    questionFilterRules,
    activeQuestionFilters,
    clearQuestionFilterRules,
    addQuestionFilter,
    removeQuestionFilter,
    updateQuestionFilter,
    updateQuestionValues
  } = useQuestionFilters(initialFilters, collect?.id)

  const {
    variableFilters,
    activeVariableFilters,
    addVariableFilter,
    removeVariableFilter,
    updateVariableFilter,
    updateVariableValues,
    clearVariableFilters
  } = useVariableFilters(initialFilters, collect?.id, loadVariableValues)

  const {
    fieldErrors,
    validateFilters,
    clearAllErrors
  } = useFilterValidation(activeQuestionFilters, activeVariableFilters)

  const hasFiltersToDestroy = useMemo(() => {
    const hasQuestionRulesToDestroy = questionFilterRules.some(rule => rule.shouldDestroy)
    const hasVariableFiltersToDestroy = variableFilters.some(filter => filter.shouldDestroy)
    return hasQuestionRulesToDestroy || hasVariableFiltersToDestroy
  }, [questionFilterRules, variableFilters])

  const clearAllFilters = () => {
    clearQuestionFilterRules()
    clearVariableFilters()
    clearAllErrors()
  }

  const filters = {
    userFilterRules: questionFilterRules,
    variableFilters
  }

  return {
    filters,
    fieldErrors,
    variableValues,

    activeVariableFilters,
    addVariableFilter,
    removeVariableFilter,
    updateVariableFilter,
    updateVariableValues,
    loadVariableValues,

    activeQuestionFilters,
    addQuestionFilter,
    removeQuestionFilter,
    updateQuestionFilter,
    updateQuestionValues,

    hasFiltersToDestroy,
    validateFilters,
    clearAllFilters
  }
}

export default useFilters
